// @ts-nocheck
import locationFinderReducer, {
    LocationFinderActions,
} from "@store/Framework/Store/Store/Pages/LocationFinder/LocationFinderReducer";
import productDetailsReducer, {
    ProductDetailsActions,
} from "@store/Framework/Store/Store/Pages/ProductDetails/ProductDetailsReducer";
import { combineReducers } from "redux";

const pagesReducer = combineReducers({
    locationFinder: locationFinderReducer,
    productDetails: productDetailsReducer,
});

export type PagesActions = ProductDetailsActions | LocationFinderActions;

export default pagesReducer;
